/* eslint @typescript-eslint/camelcase: 0 */
import { getToken } from '../../utils/auth';
import apiFetch from '../core/apiFetch';
import { checkStatus, handleError } from '../../utils/api';
import { mapPatient } from './helpers';
import { AffiliationType } from '../../interfaces/register';

const postPatientCompleteAsync = async (
  type: AffiliationType,
  affiliationId: number | null = null,
  token: string | null = null
) => {
  const url = `api/v2/patient_complete`;

  try {
    const cookieToken = getToken();
    const response = await apiFetch(token || cookieToken, url, {
      method: 'POST',
      body: JSON.stringify({
        patient: { type, affiliation_id: affiliationId },
      }),
    });

    await checkStatus(response);

    const { patient } = await response.json();
    return { error: null, patient: mapPatient(patient) };
  } catch (error) {
    handleError('unexpected status - create patient profile', error);
    return { error: true, patient: null };
  }
};

export default postPatientCompleteAsync;
